import React from 'react';
import classnames from 'classnames';
import { ReactComponent as TemplatesHighlighted } from '../../../webcommon/common/Icons/Templates-Highlighted.svg';
import { ReactComponent as TemplatesIcon } from '../../../webcommon/common/Icons/Templates.svg';
import { ReactComponent as SaveAsIcon } from '../../../webcommon/common/Icons/SaveAs.svg';
import { ReactComponent as SaveAsHighlighted } from '../../../webcommon/common/Icons/SaveAsHighlighted.svg';
import { ReactComponent as UploadTemplate } from '../../../webcommon/common/Icons/UploadTemplate.svg';
import { ReactComponent as UploadTemplateHighlighted } from '../../../webcommon/common/Icons/UploadTemplateHighlighted.svg';
import { ReactComponent as Book } from '../../../webcommon/common/Icons/Book.svg';
import { ReactComponent as BookHighlighted } from '../../../webcommon/common/Icons/BookHighlighted.svg';
import ActionButton from '../../../webcommon/common/actionbutton/ActionButton';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import Modal from '../../../webcommon/common/modal/Modal';
import FileParser from '../../../webcommon/common/filereader/FileParser';
import { csvParser } from '../../../webcommon/common/filereader/FileParsing';
import fp from 'lodash/fp';
import Dropzone from '../../../webcommon/common/dropzone/Dropzone';
import styles from './Templates.module.scss';
import TemplateRow from './TemplateRow';
import RowSelector from '../selectorrows/RowSelector';
import SaveAs from './savetemplate/SaveAs';
import OverwriteTemplate from './overwritetemplate/OverwriteTemplate';

const columnsCsvParser = csvParser({
    columns: true
});

class Templates extends React.Component {
    constructor(props) {
        super(props);
        this.toggleActive = this.toggleActive.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);
        this.openDeleteRow = this.openDeleteRow.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.saveAsTemplate = this.saveAsTemplate.bind(this);
        this.selectTemplate = this.selectTemplate.bind(this);
        this.setSaveTemplateName = this.setSaveTemplateName.bind(this);
        this.overwriteTemplate = this.overwriteTemplate.bind(this);
        this.setActiveFalse = this.setActiveFalse.bind(this);
        this.setCurrentOptionSave = this.setCurrentOptionSave.bind(this);
        this.setCurrentOptionSelect = this.setCurrentOptionSelect.bind(this);
        this.setCurrentOptionUpload = this.setCurrentOptionUpload.bind(this);
        this.setCurrentOptionEmpty = this.setCurrentOptionEmpty.bind(this);
        this.uploadError = this.uploadError.bind(this);
        this.uploadAbort = this.uploadAbort.bind(this);
        this.readFileParser = this.readFileParser.bind(this);
        this.setCurrentOptionImport = this.setCurrentOptionImport.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.state = {
            active: false,
            deleting: false,
            currentOption: '',
            rowToDelete: '',
            saveTemplateName: ''
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    onDrop(file) {
        this.props.importSensitivities(file);
        this.setActiveFalse();
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setSaveTemplateName(saveTemplateName) {
        this.setState({ saveTemplateName });
    }

    setActiveFalse() {
        this.setState({
            active: false, currentOption: '', deleting: false, saveTemplateName: ''
        });
        if (this.props.templateSaved) { this.props.setTemplateSaved(false); }
    }

    setCurrentOptionSave() {
        this.setState({ currentOption: 'Save', deleting: false });
    }

    setCurrentOptionSelect() {
        this.setState({ currentOption: 'Select', saveTemplateName: '' });
        if (this.props.templateSaved) { this.props.setTemplateSaved(false); }
    }

    setCurrentOptionUpload() {
        this.setState({
            currentOption: 'Upload', deleting: false, saveTemplateName: ''
        });
        if (this.props.templateSaved) { this.props.setTemplateSaved(false); }
    }

    setCurrentOptionImport() {
        this.setState({
            currentOption: 'Import', deleting: false, saveTemplateName: ''
        });
        if (this.props.templateSaved) { this.props.setTemplateSaved(false); }
    }

    setCurrentOptionEmpty() {
        this.setState({ currentOption: '', deleting: false });
    }

    uploadError() {
        this.setState({ currentOption: '', deleting: false });
        this.props.uploadTemplateError();
    }

    uploadAbort() {
        this.setState({ currentOption: '', deleting: false });
        this.props.uploadTemplateAbort();
    }

    cancelDelete() {
        this.setState({ deleting: false, rowToDelete: '' });
    }

    saveAsTemplate() {
        if (this.state.saveTemplateName.length === 0) {
            this.props.saveAsTemplateFailed('Cannot save a template with an empty name');
        } else if (this.props.rows.includes(this.state.saveTemplateName)) {
            this.setState({ currentOption: 'Overwrite' });
        } else {
            this.props.saveAsTemplate(this.state.saveTemplateName);
        }
    }


    overwriteTemplate() {
        this.props.saveAsTemplate(this.state.saveTemplateName);
    }

    toggleActive() {
        this.setState(prevState => ({
            active: !prevState.active,
            currentOption: ''
        }));
    }

    deleteRow() {
        this.setState({ deleting: false });
        this.props.deleteTemplate(this.state.rowToDelete);
    }

    openDeleteRow(id) {
        this.setState({
            deleting: true,
            rowToDelete: this.props.rows.find(row => row === id)
        });
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)
            && this.state.currentOption !== 'Upload' && this.state.currentOption !== 'Import') {
            this.setState({ active: false, currentOption: '' });
            if (this.props.templateSaved) { this.props.setTemplateSaved(false); }
        }
    }

    closeDropdown() {
        this.setState(({
            currentOption: '', deleting: false, saveTemplateName: ''
        }));
        if (this.props.templateSaved) this.props.setTemplateSaved(false);
    }

    selectTemplate(e) {
        this.toggleActive();
        this.props.selectTemplate(e);
    }

    readFileParser(file) {
        this.props.uploadTemplate(this.props.uploadMapping(file));
        this.setActiveFalse();
    }

    render() {
        return (
            <div ref={ this.setWrapperRef } className={ styles.templateWrapper }>
                <button
                    className={ classnames({
                        [styles.templateButton]: true,
                        [styles.inactive]: !this.state.active,
                        [styles.active]: this.state.active
                    }) }
                    type="button"
                    onClick={ this.toggleActive }
                >
                    Templates <TemplatesIcon />
                </button>

                {this.state.active ? (
                    <div className={ styles.wrapper }>
                        <div>
                            <TemplateRow
                                activeRow={ this.state.currentOption === 'Save' }
                                icon={ this.state.currentOption === 'Save' ? <SaveAsHighlighted /> : <SaveAsIcon /> }
                                message="Save As Template"
                                setCurrentOption={ this.setCurrentOptionSave }
                                showExtendIcon
                                styles={ styles }
                            />
                            {this.state.currentOption === 'Save' ? (
                                <SaveAs
                                    inProcessOfSaving={ this.props.templateInProcessOfSaving }
                                    saveAsTemplate={ this.saveAsTemplate }
                                    setSaveTemplateName={ this.setSaveTemplateName }
                                    templateSaveName={ this.state.saveTemplateName }
                                    templateSaved={ this.props.templateSaved }
                                />
                            ) : null}
                            {this.state.currentOption === 'Overwrite' ? (
                                <OverwriteTemplate
                                    cancel={ this.closeDropdown }
                                    inProcessOfSaving={ this.props.templateInProcessOfSaving }
                                    overwriteTemplate={ this.overwriteTemplate }
                                    templateSaved={ this.props.templateSaved }
                                />
                            ) : null
                            }
                        </div>

                        <div>
                            <TemplateRow
                                activeRow={ this.state.currentOption === 'Select' }
                                icon={ this.state.currentOption === 'Select' ? <TemplatesHighlighted /> : <TemplatesIcon /> }
                                message="Select Template"
                                setCurrentOption={ this.setCurrentOptionSelect }
                                showExtendIcon
                                styles={ styles }
                            />
                            {this.state.currentOption === 'Select' ? (
                                <RowSelector
                                    cancelDelete={ this.cancelDelete }
                                    closeDropdown={ this.closeDropdown }
                                    deleteRow={ this.deleteRow }
                                    deletingRow={ this.state.deleting }
                                    openDeleteRow={ this.openDeleteRow }
                                    rows={ this.props.rows.filter(row => !row.deletable) }
                                    rowToDelete={ this.state.rowToDelete.name }
                                    selectTemplate={ this.selectTemplate }
                                    setSelected={ noop }
                                    title="Templates"
                                />
                            ) : null}
                        </div>
                        <div>
                            <TemplateRow
                                activeRow={ this.state.currentOption === 'Upload' }
                                icon={ this.state.currentOption === 'Upload' ? <UploadTemplateHighlighted /> : <UploadTemplate /> }
                                message="Upload Template"
                                setCurrentOption={ this.setCurrentOptionUpload }
                                styles={ styles }
                            />
                        </div>

                        <div>
                            <TemplateRow
                                activeRow={ this.state.currentOption === 'Import' }
                                icon={ this.state.currentOption === 'Import' ? <BookHighlighted /> : <Book /> }
                                message="Import Sensitivities"
                                setCurrentOption={ this.setCurrentOptionImport }
                                styles={ styles }
                            />
                        </div>
                        <Modal
                            isOpen={ this.state.currentOption === 'Upload' }
                            closeModal={ this.setCurrentOptionEmpty }
                        >
                            <FileParser
                                onAbort={ this.uploadAbort }
                                onError={ this.uploadError }
                                onRead={ this.readFileParser }
                                parseMethod={ columnsCsvParser }
                            />
                        </Modal>

                        <Modal
                            isOpen={ this.state.currentOption === 'Import' }
                            closeModal={ this.setCurrentOptionEmpty }
                        >
                            <Dropzone onDrop={ this.onDrop } />
                        </Modal>
                        <div className={ styles.closeButton }>
                            <ActionButton
                                accent
                                onClick={ this.setActiveFalse }
                            >
                                Close
                            </ActionButton>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

Templates.propTypes = {
    deleteTemplate: PropTypes.func,
    importSensitivities: PropTypes.func,
    rows: PropTypes.arrayOf(PropTypes.string),
    saveAsTemplate: PropTypes.func,
    saveAsTemplateFailed: PropTypes.func,
    selectTemplate: PropTypes.func,
    setTemplateSaved: PropTypes.func,
    templateInProcessOfSaving: PropTypes.bool,
    templateSaved: PropTypes.bool,
    uploadMapping: PropTypes.func,
    uploadTemplate: PropTypes.func,
    uploadTemplateAbort: PropTypes.func,
    uploadTemplateError: PropTypes.func
};

Templates.defaultProps = {
    deleteTemplate: noop,
    importSensitivities: noop,
    rows: [],
    saveAsTemplate: noop,
    saveAsTemplateFailed: noop,
    selectTemplate: noop,
    setTemplateSaved: noop,
    templateInProcessOfSaving: false,
    templateSaved: false,
    uploadMapping: fp.identity,
    uploadTemplate: noop,
    uploadTemplateAbort: noop,
    uploadTemplateError: noop
};

export default Templates;
